export interface EmployeeJobStepUp {
  employeeJobStepUpID: string;
  employeeJobID: string;
  date: Date;
  jobClass: string;
  jobClassID: number | null;
  payRate: number | null;
  note: string;
  createdBy?: string | null;
  createdDate?: string | null;
  modifiedBy?: string | null;
  modifiedDate?: string | null;
  bActive: boolean;
}
